module.exports = __webpack_public_path__ + "media/images/flags/gi-a87ba99e6a20309b6e82aad26249470c.svg";